import { FormItemType } from "../../../UI/view/component-map";
import { ListViewColumnType } from "../../../UI/view/list-view";
import { updatePsig, updateValues } from "../../../../services/requests/billing/liquid-billing-requests";
import { formatCurrency } from "../../../../services/format";

export const bulkLineItem = ({ label, fieldName, hideCheck, hideRow }: { label: string, fieldName: string, hideCheck?: boolean, hideRow?: ({ watch }) => boolean }) => {
  return (
    {
      type: FormItemType.row,
      hideIf: hideRow ? hideRow : undefined,
      items: [
        {
          name: `${fieldName}OverrideBOOL`,
          defaultValue: false,
          type: FormItemType.checkboxField,
          tooltip: 'Override',
          width: 100,
          hideIf: hideCheck ? () => true : undefined,
        },
        {
          type: FormItemType.label,
          label: label,
          name: label,
          width: 200
        },
        {
          name: fieldName,
          disabled: () => true,
          hide: ({ watch }) => {
            return watch(`${fieldName}OverrideBOOL`);
          },
          hideIf: ({ editTableProps, rowIdentity, watch }) => {
            return watch(`${fieldName}OverrideBOOL`);
          },
          number: true,
          defaultValue: 0,
          fitToContent: true,
          required: true,
          width: 200,
          min: 0,
        },
        {
          name: `${fieldName}Override`,
          hide: ({ watch }) => {
            return !watch(`${fieldName}OverrideBOOL`);
          },
          hideIf: ({ editTableProps, rowIdentity, watch }) => {
            return !watch(`${fieldName}OverrideBOOL`);
          },
          number: true,
          computedValue: (getValues) => {
            console.log(getValues(fieldName));
            return getValues(fieldName);
          },
          /*    defaultValue: 0, */
          fitToContent: true,
          required: true,
          width: 200,
          min: 0,
        },

      ]
    }
  );
}

export const liquidBulkLineItems = [
  bulkLineItem({ label: 'Gross volume (CF)', fieldName: 'nvValue' }),
  bulkLineItem({ label: 'Helium Charge', fieldName: 'bcValue' }),
  bulkLineItem({ label: 'Depressurization charge', fieldName: 'dcValue' }),
  bulkLineItem({ label: 'Temp at 3PSIG', fieldName: 'heTempAt3Psig', hideRow: ({ watch }) => watch('isStagingInvoice') }),
  bulkLineItem({ label: 'Cooldown charge', fieldName: 'ccValue' }),
  bulkLineItem({ label: 'Nitrogen charge', fieldName: 'ncValue' }),
  bulkLineItem({ label: 'Inland Freight', fieldName: 'tcValue' }),
  bulkLineItem({ label: 'Service charge', fieldName: 'scValue' }),
  bulkLineItem({ label: 'Analytical charge', fieldName: 'acValue' }),
  bulkLineItem({ label: 'Repair charge', fieldName: 'rcValue' }),
  bulkLineItem({ label: 'Export Insp. Charge', fieldName: 'ecValue' }),
  bulkLineItem({ label: 'Container Wash', fieldName: 'cwValue' }),
  bulkLineItem({ label: 'Ocean Freight', fieldName: 'ofValue' }),
  bulkLineItem({ label: 'Export Fee', fieldName: 'efValue' }),
  bulkLineItem({ label: 'Customs & Broker Fee', fieldName: 'cfValue' }),
  bulkLineItem({ label: 'Forwarding & Cust Fee', fieldName: 'ffValue' }),

]


export const bulkItemEditGrid = {

  type: FormItemType.editTable,
  name: 'liquidBillingDetails',
  variant: 'small',
  pk: 'id',
  hideAddButton: false,
  toolbar: [
    {
      type: FormItemType.row,
      items: [
        {
          type: FormItemType.button,
          fitToContent: true,
          label: 'Update Values',
          hideIf: ({ watch }) => watch('isStagingInvoice'),
          handler: async ({ methods, editTableProps, confirm, redirect }) => {
            try {
              await updateValues({ billingId: methods.getValues('billingId') });
              await confirm('Values Updated', true);
              //location.reload();
              methods.loadEntity();
            } catch (e) {
              await confirm('Failed to update values.', true);
            }
          }
        },
        {
          type: FormItemType.button,
          label: 'Recalculate 3PSIG',
          fitToContent: true,
          hideIf: ({ watch }) => watch('isStagingInvoice'),
          handler: async ({ methods, editTableProps, confirm, redirect }) => {
            try {
              const tempOverride = methods.getValues('heTempAt3PsigOverride');
              await updatePsig({ billingId: methods.getValues('billingId'), tempOverride });
              await confirm('3PSIG recalculated.', true);
              methods.loadEntity();
            } catch (e) {
              await confirm('Failed to recalculate 3PSIG.', true);
            }
          }
        },
        {
          type: FormItemType.text,
          name: 'heTempAt3PsigOverride',
          label: 'Temp At 3Psig',
          inline: true,
          fitToContent: true,
          hide: ({ watch }) => watch('isStagingInvoice'),
          computedValue: (getValues, editTableProps, watch) => {
            const psig = watch(`heTempAt3Psig`);
            return psig;
          }
        },
        {
          name: 'detailsTotal',
          type: FormItemType.labelField,
          style: { float: 'right', fontWeight: 'bold' },
          computedValue: (getValues, editTableProps, watch) => {
            const datum = getValues('liquidBillingDetails');
            const sumTotal = datum?.reduce((acc, currentValue) => acc + (currentValue.valueType == 'NV' ? 0 : (currentValue.overrideValue != null ? Number(currentValue.overrideValue) : Number(currentValue.value) ?? 0)), 0) ?? 0;
            return 'Total: ' + formatCurrency(sumTotal || 0);
          }
        },
      ]
    }
  ],
  columns: [
    {
      type: ListViewColumnType.delete,
      id: 'deleteme'
    },
    {
      Header: 'Value Type',
      accessor: 'valueType',
      formItemProps: {
        name: 'valueType',
        type: FormItemType.select,
        required: true,
        defaultValue: null,
        options: [
          { id: null, text: '' },
          { id: 'NV', text: 'Gross volume (CF)' },
          { id: 'BC', text: 'Helium Charge' },
          { id: 'DC', text: 'Depressurization Charge' },
          { id: 'CC', text: 'Cooldown Charge' },
          { id: 'NC', text: 'Nitrogen Charge' },
          { id: 'TC', text: 'Inland Freight' },
          { id: 'SC', text: 'Service Charge' },
          { id: 'AC', text: 'Analytical Charge' },
          { id: 'RC', text: 'Repair Charge' },
          { id: 'EC', text: 'Export Insp. Charge' },
          { id: 'CW', text: 'Container Wash' },
          { id: 'OF', text: 'Ocean Freight' },
          { id: 'EF', text: 'Export Fee' },
          { id: 'CF', text: 'Customs & Broker Fee' },
          { id: 'FF', text: 'Forwarding & Cust Fee' },
          { id: 'MC', text: 'Misc Charge' },
          { id: 'HS', text: 'Helium Surcharge' },
          { id: 'HC', text: 'Helium Surcharge (HC)' },
        ]
      }
    },
    {
      Header: 'Value',
      accessor: 'value',
      formItemProps: {
        name: 'value',
        disabled: () => true
      }
    },
    {
      Header: 'Override',
      accessor: 'overrideValue',
      formItemProps: {
        name: 'overrideValue',
        disabled: ({watch, editTableProps, getValues }) => {
          let valueType = watch(`liquidBillingDetails[${editTableProps.rowIdentity}][valueType]`); 
          return valueType  == 'BC';
        },
        number: true,
      },
    },
    {
      Header: 'Description',
      accessor: 'itemDescription',
      formItemProps: {
        name: 'itemDescription',
      }
    },
  ]
};